import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import logo from '../../src/assets/logo.png';
import { login } from '../store/actions/userLoginAction';
const LoginScreen = () => {
  const navigate = useNavigate();
  const userLogin = useSelector((state) => state.userLogin);
  const dispatch = useDispatch();
  // const {
  //   register,
  //   handleSubmit,
  //   reset,
  //   formState: { errors },
  // } = useForm();
  const onSubmit = (data) => {
    dispatch(login(data));
    navigate('/');
  };

  return (
    <>
      <div className='h-screen flex items-center justify-center  bg-neutral-300'>
        <div className='bg-black py-10 px-10 w-full mx-2	md:w-1/4'>
          <div className='sm:mx-auto sm:w-full sm:max-w-sm  '>
            <img
              className='mx-auto h-10 w-auto bg-black  '
              src={logo}
              alt='Your Company'
            />
            <h2 className='my-5  text-center text-2xl font-bold leading-9 tracking-tight text-white'>
              Sign in to your account
            </h2>
          </div>

          <div className=' '>
            {userLogin?.error && (
              <span className='text-rose-500'>
                {'কিরে ভাই নিজের আইডি ভুলে গেছেন ?? বাহ !!'}
              </span>
            )}
            <form
              className=' '
              // action='#'
              // onSubmit={handleSubmit(onSubmit)}
            >
              <div>
                <label
                  htmlFor='email'
                  className='block text-sm font-medium leading-6 text-white text-start'
                >
                  User Name
                </label>
                {/* 
                <FromInput
                  type='text'
                  name='username'
                  placeholder='Enter username or email'
                  register={register}
                  errors={errors}
                  required={true}
                /> */}
              </div>

              <div>
                <div className='flex items-center justify-between'>
                  <label
                    htmlFor='password'
                    className='block text-sm font-medium leading-6 text-white'
                  >
                    Password
                  </label>
                  <div className='text-sm'>
                    <a
                      href='#'
                      className='font-semibold text-yellow-300 hover:text-white'
                    >
                      Forgot password?
                    </a>
                  </div>
                </div>
                <div className='mt-2'>
                  {/* <FromInput
                    type='password'
                    name='password'
                    placeholder='Enter password'
                    register={register}
                    errors={errors}
                    required={true}
                  /> */}
                </div>
              </div>

              <button
                type='submit'
                className='flex px-5 rounded-md  py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 bg-purple-600'
              >
                Sign in
              </button>
            </form>

            {/* <p className='mt-10 text-center text-sm  text-rose-200'>
              {`Not a member? `}
              <a
                href='#'
                className='font-semibold leading-6 text-yellow-300 hover:text-white'
              >
                Start a 14 day free trial
              </a>
            </p> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginScreen;
